export default "__VITE_ASSET__YaxyJJls__"